enum LoadState {
    INIT,
    LOADING,
    FAILED,
    LOADED,
}

export default LoadState;
